module.exports = __webpack_public_path__ + "img/profile-image-placeholder.008c7398.png";